import { Button, ButtonProps, CircularProgress, Menu, MenuItem } from '@mui/material';
import React, { cloneElement, isValidElement, useState } from 'react';

export interface ActionItem {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  loading?: boolean;
  disabled?: boolean;
}

interface ActionMenuProps extends Partial<ButtonProps> {
  label: string;
  items: any[];
}

export function ActionMenuButton({ label, items, ...props }: ActionMenuProps) {
  const [anchor, setAnchor] = useState<null | HTMLElement>(null);
  const filteredItems = items.filter(Boolean) as ActionItem[];

  if (!filteredItems.length) return null;

  return (
    <>
      <Button
        size="small"
        variant="contained"
        {...props}
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{
          borderRadius: '8px', // Angoli più morbidi e moderni
          textTransform: 'none', // Evita il tutto maiuscolo aggressivo
          fontWeight: 500,
          px: 2,
          py: 0.75,
          ...props.sx
        }}>
        {label}
      </Button>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {filteredItems.map((item, i) => (
          <MenuItem
            key={i}
            disabled={item.disabled || item.loading}
            onClick={() => {
              item.onClick();
              setAnchor(null);
            }}
            sx={{
              typography: 'body2',
              fontWeight: 500,
              py: 1,
              px: 1.5,
              display: 'flex',
              alignItems: 'center',
              color: 'text.primary',
              transition: 'all 0.15s ease-in-out',
              '&:hover': {
                backgroundColor: 'action.hover',
                color: 'primary.main', // Cambio colore del testo soft all'hover
                '& svg': {
                  color: 'primary.main' // Anche l'icona si illumina all'hover
                }
              },
              '&.Mui-disabled': {
                opacity: 0.6
              }
            }}>
            {item.loading ? (
              <CircularProgress size={16} color="inherit" sx={{ mr: 1.5 }} />
            ) : (
              isValidElement(item.icon) &&
              cloneElement(item.icon as React.ReactElement<any>, {
                sx: {
                  fontSize: 18,
                  color: 'text.secondary',
                  mr: 1.5,
                  ...((item.icon.props as any).sx || {})
                }
              })
            )}
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
